module.exports = __webpack_public_path__ + "static/media/piper-dialog1-mobile.552bc632.svg";